"use client";

import { Box, Typography } from "@mui/material";
import { Article } from "./articles/Article";
import { HubListingArticle } from "./HubListingArticle";
import { HUB_BREADCRUMBS, HubBreadcrumbs } from "./HubBreadcrumbs";

export function HubListingPage({ articles }: { articles: Article[] }) {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: "grey.200",
        paddingTop: 2,
        paddingBottom: 8,
        flex: 'stretch',
        [theme.breakpoints.down("sm")]: {
          backgroundColor: "white",
        },
      })}
    >
      <Box
        sx={{
          maxWidth: "800px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <HubBreadcrumbs breadcrumbs={[HUB_BREADCRUMBS.hub]} />
        <Typography
          variant="h4"
          component="h1"
          sx={(theme) => ({
            padding: theme.spacing(0, 4),
            [theme.breakpoints.down("sm")]: {
              padding: theme.spacing(0, 2),
            },
          })}
        >
          Horsezone Hub
        </Typography>
        <Box
          sx={(theme) => ({
            padding: 4,
            borderRadius: 10,
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            [theme.breakpoints.down("sm")]: {
              padding: 2,
              borderRadius: 0,
            },
          })}
        >
          {articles.map((article) => (
            <HubListingArticle key={article.slug} article={article} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
